import uploadProgress from '../actions/uploadProgress.js'

export default [uploadProgress]



// WEBPACK FOOTER //
// ./src/modules/user/chains/uploadProgress.js